import {createAction} from 'redux-actions';
import {getQcToolsMetadataGenres} from '@pluto/rest';

export const SET_QC_GENRES = 'SET_QC_GENRES';

export const setQcGenres = createAction<Promise<any>, number>(SET_QC_GENRES, async () => {
    return await getQcToolsMetadataGenres();
});
